import styled from 'styled-components';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
const getSharedStyles = theme => ({
  position: 'sticky',
  left: 0,
  background: 'inherit',
  zIndex: 1,
  boxShadow: `inset 0 -1px 0 ${theme.color['border-primary-subtle']}, 5px 0 5px -5px ${theme.color['border-primary-subtle']}`,
  borderStyle: 'none !important',
  '&::after': {
    boxShadow: `5px 0 5px -5px inset ${theme.color['border-primary-subtle']}`,
    content: '" "',
    height: '100%',
    position: 'absolute',
    top: 0,
    right: '-5px',
    width: '5px'
  }
});
export const StickyCellNameColumn = styled.td.withConfig({
  displayName: "StickyCellNameColumn",
  componentId: "sc-1cwu1b5-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, getSharedStyles(theme));
});
export const StickyHoverCellNameColumn = styled(UITableHoverCell)(({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, getSharedStyles(theme));
});